import type { Citation } from "@metalmind-ab/mmagent-chat-ui";

/** Workspace chunk citations identify the document in extra, not their chunk id. */
export function getCitationDocumentId(citation: Citation | null): string | null {
  const documentId = citation?.extra?.doc_id;
  if (typeof documentId === "string" && documentId) return documentId;
  return citation?.id || null;
}
